__turbopack_context__.v({
  "className": "poppins_46093f66-module__NW755W__className",
});
